import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { OnActionEvent, PaginationBase, PColumn, QuickTableComponent } from '@dataclouder/ngx-core';
import { NgxTtsService } from '../../services/ngx-tts.service';
import { TTSVoice } from '../../models/models';

@Component({
  selector: 'lib-voice-selector',
  imports: [QuickTableComponent],
  template: ` @if(voices.length > 0){
    <app-quick-table [columns]="columns" [tableData]="voices" (onAction)="doSelect($event)"></app-quick-table>
    }`,
  styleUrl: './voice-selector.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceSelectorComponent extends PaginationBase {
  private ttsService = inject(NgxTtsService);
  private cdr = inject(ChangeDetectorRef);
  public voices: TTSVoice[] = [];

  protected override columns: PColumn[];
  protected override loadData(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async ngOnInit() {
    console.log('Voice selector initialized');

    // TODO ❗️ ayudararia filtar voces por idioma

    const voices = await this.ttsService.listVoices();
    this.voices = voices;
    console.log('after voices', this.voices);

    this.cdr.detectChanges();
  }

  public doSelect(event: OnActionEvent) {
    console.log('Selected voice:', event);
    this.onAction.emit(event);
  }
}
